import { Text } from '@chakra-ui/react'
import { memo } from 'react'

const ProductsListEmpty = () => {
  return <Text>Nenhum resultado encontrado.</Text>
}

export default memo(ProductsListEmpty)
